module.exports = __webpack_public_path__ + "main/assets/public/special-mode/radiothon-2018/lightning.3b7393c77a05384c.png";